import { IFilesystemListItem } from '@/dataroom/domain/vo/collection/FilesystemListItem';
import { canRedactFileByKeyword } from '@/dataroom/domain/filesystemPermissions';

export const filterSelectedFiles = (selected: IFilesystemListItem[]) => (
  selected.filter((item) => canRedactFileByKeyword(item, selected.length))
);
